import "../../../assets/presentation/components/modal-views/close-modal-button-CyiykZWY.css";
import { Icon, IconVariation } from "../controls/icon/icon2.js";
import { ButtonPriority, CircleButton } from "../controls/button/button2.js";
import { ButtonIcon } from "../controls/button/button-icon2.js";
/* empty css                   */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/modal-views/close-modal-button.tsx
var CloseModalButton = ({ className, onClick }) => /* @__PURE__ */ jsx(CircleButton, {
	className: classNames(className, "close-modal-button"),
	priority: ButtonPriority.TEXT,
	onClick,
	children: /* @__PURE__ */ jsx(ButtonIcon, { children: /* @__PURE__ */ jsx(Icon, {
		icon: "close",
		variation: IconVariation.OUTLINED
	}) })
});
//#endregion
export { CloseModalButton };

//# sourceMappingURL=close-modal-button2.js.map